import { AxiosPromise } from 'axios';

import { apiInstance } from 'shared/api/typicode/base';

const BASE_URL = '/files';

export type UploadAvatarResponse = {
  size: string;
  name: string;
  path: string;
  id: string;
};

/**
 * Загрузка аватара автора
 * @param file - Файл изображения (JPEG, PNG, WebP)
 * @returns Promise с данными загруженного файла
 */
export const uploadAvatar = async (file: File): AxiosPromise<UploadAvatarResponse> => {
  const formData = new FormData();
  formData.append('file', file);

  return apiInstance.post(`${BASE_URL}/avatar`, formData, {
    headers: {
      Authorization: `Bearer ${window.localStorage.getItem('token') ?? ''}`,
      'Content-Type': 'multipart/form-data',
    },
  });
};

/**
 * Получение файла по пути
 * @param path - Путь к файлу
 * @returns Promise с данными файла (blob)
 */
export const getFileByPath = async (path: string): AxiosPromise<Blob> =>
  apiInstance.get(`${BASE_URL}/doc/${path}`, {
    headers: {
      Authorization: `Bearer ${window.localStorage.getItem('token') ?? ''}`,
    },
    responseType: 'blob',
  });
